import { render, staticRenderFns } from "./collection-counter.vue?vue&type=template&id=0b7e4802&lang=pug"
import script from "./collection-counter.vue?vue&type=script&lang=js"
export * from "./collection-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports